import { Plugin } from "grapesjs";
import loadComponents from "./components";
import loadBlocks from "./block";
import {
  PluginOptions,
  RequiredPluginOptions,
} from "../../../../../types/types";

const plugin: Plugin<PluginOptions> = (editor, opts = {}) => {
  const options: RequiredPluginOptions = {
    id: "contact-us",
    label: "Contact",
    block: {},
    style: "",
    styleAdditional: "",
    classPrefix: "contact-us",
    ...opts,
  };

  loadBlocks(editor, options);
  loadComponents(editor, options);
};

export default plugin;
